import ListItemHighlight from '../../../shared/support/ListItemHighlight';
import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {},
  error: undefined,
  selectable: false,
  selectedRowKeys: [],
  selectedRows: [],
  pagination: {
    limit: 25,
  },
};

const highlight = (store, data) => {
  const { data: retenciones } = store.state.app.retenciones.list;

  const tool = new ListItemHighlight(retenciones);

  store.setState((state) => {
    state.app.retenciones.list.data = tool.getNewList(data, true);
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.retenciones.list.busy = true;
  });

  try {
    const params = {
      ...meta,
    };

    const response = await Http.get('api/retenciones', { params });

    store.setState((state) => {
      state.app.retenciones.list.busy = false;
      state.app.retenciones.list.data = response.data;

      state.app.retenciones.list.pagination = {
        ...state.app.retenciones.list.pagination,
        ...response.meta.pagination,
        limit: params.limit || state.app.retenciones.list.pagination.limit,
      };

      state.app.retenciones.list.filters = {
        ...state.app.retenciones.list.filters,
        ...meta,
      };
    });

    setTimeout(() => {
      store.setState((state) => {
        state.app.retenciones.list.search = 'AS';
      });
    }, 500);
  } catch (error) {
    store.setState((state) => {
      state.app.retenciones.list.error = error.data || error;
      state.app.retenciones.list.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.app.retenciones.list.error = undefined;
};

const setSelectable = (store, selectable) => (state) => {
  state.app.retenciones.list.selectable = selectable;
};

const setSelection = (store, selectedRows, selectedRowKeys) => {
  return (state) => {
    state.app.retenciones.list = {
      ...state.app.retenciones.list,
      selectedRows: selectedRows,
      selectedRowKeys: selectedRowKeys,
    };
  };
};

const clearSelection = () => {
  return (state) => {
    state.app.retenciones.list = {
      ...state.app.retenciones.list,
      selectable: false,
      selectedRowKeys: [],
      selectedRows: [],
    };
  };
};

const actions = {
  paginate,
  resetError,
  setSelectable,
  setSelection,
  clearSelection,
  highlight,
};

const RetencionesListStore = {
  state: () => initialState,
  actions,
};

export default RetencionesListStore;
